module.exports = __webpack_public_path__ + "img/services2.e50e034b.png";